var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingDiv"},[_c('van-loading',{attrs:{"size":"24px","vertical":"","type":"spinner"}},[_vm._v("校验订单中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }